import React from 'react'
import Link from 'next/link'
import styles from './search.module.scss'

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tags: Array<any>
}

const SearchTag = ({ tags }: Props) => (
  <div className={styles.tagContainer}>
    {tags.length > 0 && (
      <div className="hidden-sm">
        <h2 className="tx-oswald tx-16 tx-gish tx-w300 mb-4">Tags</h2>
        <div className="d-flex flex-wrap">
          {tags.map((tag) => (
            <Link
              as={`/tag/${tag}`}
              href={`/tag?q=${tag}`}
              key={`tag-${tag}`}
              className={`tx-12 ${styles.tag}`}
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>
    )}
  </div>
)

export default SearchTag
